import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import moment from 'moment';
import styled from 'styled-components';

import '../../../index.css';
import Title from '../../../components/Title';
import LinkGoods from './LinkGoods';
import {
  getSlideList,
  addSlide,
  uploadImage,
  deleteSlide,
  addContents,
  updateContents,
  updateSlide,
  addItem,
  getUserDetail,
  getPublishedContentByNo,
  getPublishedContentsList
} from '../../../modules/NetworkFunction';
import { useContext } from 'react';
import AuthContext from '../../../contexts/AuthContext';
import ShopModeContext from '../../../contexts/ShopModeContext';
import slidePrev_Img from '../../../icons/ic-slidePrev.png';
import slideNext_Img from '../../../icons/ic-slideNext.png';
import videoPlay_Img from '../../../icons/ic-videoPlay.png';
import videoPause_Img from '../../../icons/ic-videoPause.png';
import slideAdd_Img from '../../../icons/ic-slideAdd.png';
import slideDelete_Img from '../../../icons/ic-slideDelete.png';
import slideAdd_not_able_Img from '../../../icons/ic-slideAdd-not-able.png';
import slideDelete_not_able_Img from '../../../icons/ic-slideDelete-not-able.png';
import PreviewPage from '../Preview/PreviewPage';
import VideoPlayer from '../../../components/VideoPlayer';
import closeIcon from '../../../icons/ic-close.png';
import faceIcon from '../../../icons/ic-face2.png';
import deleteIcon from '../../../icons/ic-delete.png';
import prevIcon from '../../../icons/ic-prev.png';
import nextIcon from '../../../icons/ic-next.png';

function ImageRegist({ history, closeModal, isPaid }) {
  //위즈몬에서 이식된(필요한) 코드
  const location = useLocation();
  const [video, setVideo] = useState(
    location.state?.isModify ? location.state?.videoURL ?? "" : location.state?.video ?? ""
  );
  const [videoUrl, setVideoUrl] = useState(
    'https://www.youtube.com/embed/' + video
  );
  
  const [selectedProduct, setSelectedProduct] = useState(location.state.selectedProduct);
  const [conNum, setConNum] = useState(location.state.contentsNo);

  const [contentNumber, setContentNumber] = useState(0);
  const [state, setState] = useState({
    selected: '',
    search: location.state?.title ?? '',
  });
  const { auth: token } = useContext(AuthContext);

  const handleSearch = (e) => {
    setState({ search: e.target.value });
  };

  const PushToContents = () => {
    history.push({
      pathname: '/mypage/contents-list',
    });
  };

  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

  const [playerDuration, setPlayerDuration] = useState(300);
  const [currentTime, setCurrentTime] = useState(0);
  const [isScrolling, setIsScrolling] = useState(false);

  const playerRef = useRef();
  const timelineRef = useRef();

  const TIMELINE_RULER_WIDTH = 7;
  const [TIMELINE_MULTIPLIER, setTIMELINEMULTIPLIER] = useState(2);
  const [playing, setPlaying] = useState(true);
  const [currentSlideIdx, setCurrentSlideIdx] = useState(0);
  const [deleteSlideNumList, setDeleteSlideNumList] = useState([]);
  const { shopMode } = useContext(ShopModeContext);
  const [userDetail, setUserDetail] = useState(null);

  const [publishedContentNo, setPublishedContentNo] = useState(location.state.publishedContentNo);
  const [publishedContent, setPublishedContent] = useState();
  const [publishedContents, setPublishedContents] = useState([]);

  // 슬라이드 저장 ref
  const reviewItemRef = {
    itemNo: null,
    imageURL: null,
    displayTime: 0, // 시작 시간
    itemImage: null,
    name: null,
    price: null,
  };

  const [reviewList, setReviewList] = useState([
    {
      ...reviewItemRef,
    },
  ]);

  useEffect(() => {
    getPublishedContentByNo(
      { publishedContentNo },
      (v) => {
        console.log(v)
        setPublishedContent(v);
      },
      () => {

      },
      (e) => {
        console.log(e)
      },
      token
    )
  }, [])

  useEffect(() => {
    getPublishedContentsList(
      { userNo: userDetail?.userNo },
      (v) => {
        console.log(v)
        setPublishedContents(v);
      },
      () => {

      },
      (e) => {
        console.log(e)
      },
      token
    )
  }, [userDetail])

  useEffect(() => {
    getUserDetail(
      null,
      (data) => {
        setUserDetail(data.user);
      },
      () => { },
      (e) => {
        console.log(e);
      },
      token
    );
  }, [token]);

  useEffect(() => {
    // 모바일 화면 미리보기 페이지 본 후 다시 돌아왔을 때
    if (history.action === 'REPLACE') {
      setReviewList(location.state.slideList);
      setVideoUrl(location.state.videoUrl);
      setState({ search: location.state.title });
      setProducts(location.state.productList);
    }
  }, []);

  // 슬라이드 추가 함수
  const addReviewItem = (toIdx, displayTime) => {
    /* displayTime: 현재 재생 시간*/
    // console.log("addReviewItem");
    const nextSlideTime = displayTime || playerDuration;
    // console.log("nextSlideTime", nextSlideTime);
    const review = {
      ...reviewItemRef,
      displayTime:
        displayTime || (nextSlideTime - reviewList[toIdx].displayTime) / 2,
    };
    setReviewList(
      reviewList.concat(review).sort((a, b) => {
        if (a.displayTime < b.displayTime) {
          return -1;
        }
        if (a.displayTime > b.displayTime) {
          return 1;
        }
      })
    );

    setCurrentSlideIdx(currentSlideIdx + 1);
  };

  const deleteReviewItem = (idx) => {
    if (idx === 0) {
      return;
    }
    if (reviewList[idx].slideNo != null) {
      setDeleteSlideNumList(
        deleteSlideNumList.concat({ slideNo: reviewList[idx].slideNo })
      );
    }
    setReviewList(reviewList.filter((item, index) => index !== idx));
    setCurrentSlideIdx(idx - 1);
  };

  const timerId = useRef();

  useEffect(() => {
    const checkPlayer = () => {
      const time = currentTime;

      for (let i = 0; i < reviewList.length; i++) {
        //현재 영상 101초 재생중 -
        //slideList = [10, 20, 100, 200 ]
        if (reviewList[i].displayTime > time) {
          //console.warn("currentTime", reviewList[i].displayTime, currentTime)
          let index = i < 1 ? 0 : i - 1;
          setCurrentSlideIdx(index);
          // console.log(index);
          break;
        }
        //마지막 장 재생
        else if (i === reviewList.length - 1) {
          // console.warn("currentTime2", reviewList[i].displayTime, currentTime)
          setCurrentSlideIdx(i);
        }
      }
      timelineRef.current.scrollLeft = currentTime * TIMELINE_MULTIPLIER;
    };
    checkPlayer();
  }, [currentTime, reviewList]);

  const _setPage = (reviewItem, index) => {
    setCurrentTime(reviewItem.displayTime);
    playerRef.current.seekTo(reviewItem.displayTime);
  };

  const Slides = reviewList.map((item, index) => {
    let width =
      reviewList.length == index + 1
        ? playerDuration - item.displayTime
        : reviewList[index + 1].displayTime - item.displayTime;
    width = width * TIMELINE_MULTIPLIER;

    return index === currentSlideIdx ? (
      <div
        className="selected-slide"
        key={item.displayTime}
        style={{
          width: width,
          overflow: 'hidden',
          touchAction: 'none',
        }}
        onClick={() => {
          if (currentSlideIdx !== index) {
            _setPage(item, index);
          }
        }}
      />
    ) : (
      <div
        className="slide"
        key={item.displayTime}
        style={{
          width: width,
          overflow: 'hidden',
          touchAction: 'none',
        }}
        onClick={() => {
          if (currentSlideIdx !== index) {
            _setPage(item, index);
          }
        }}
      />
    );
  });

  const uploadSlideImage = (current, e) => {
    let cur = current;
    const formData = new FormData();

    // formData.append('name', e.target.files[0].name)
    formData.append('images', e.target.files[0]);
    console.log('이미지:', e.target.files[0])
    // 응답은 file로 받으면 됨
    uploadImage(
      formData,
      (response) => {
        setReviewList(
          reviewList.map((item, index) =>
            index === cur ? { ...item, imageURL: response.file } : item
          )
        );
      },
      () => { },
      (e) => {
        console.log(e);
      }
    );
  };

  const deleteSlideImage = (current) => {
    let cur = current;
    const deleteItem = (item) => {
      item.imageURL = null;
      return item;
    };
    setReviewList(
      reviewList.map((item, index) => (index === cur ? deleteItem(item) : item))
    );
  };

  const deleteProduct = (currentSlideIdx) => {
    let cur = currentSlideIdx;
    const deleteItem = (item) => {
      item.itemNo = null;
      item.itemImage = null;
      item.name = null;
      item.price = null;
      item.date = null;

      return item;
    };
    setReviewList(
      reviewList.map((item, index) => (index === cur ? deleteItem(item) : item))
    );
  };

  const [isContentReady, setIsContentReady] = useState(false);

  useEffect(() => {
    if (!isContentReady && conNum != null) {
      console.log('load success');
      // console.log(conNum);
      setContentNumber(conNum);
      getReviewList(conNum);
    }
  }, [isContentReady, conNum]);

  useEffect(() => {
    if (selectedProduct) {
      const price =
        shopMode === 'cafe24'
          ? selectedProduct.price
          : selectedProduct.sellprice;
      const itemImage =
        shopMode === 'cafe24'
          ? selectedProduct.list_image
          : userDetail.makeshopURL + selectedProduct.tinyimage;

      let params = {
        name: selectedProduct.product_name,
        price:
          shopMode === 'cafe24'
            ? selectedProduct.price
            : selectedProduct.sellprice,
        itemImage:
          shopMode === 'cafe24'
            ? selectedProduct.list_image
            : userDetail.makeshopURL + selectedProduct.tinyimage,
        productNo:
          shopMode === 'cafe24'
            ? selectedProduct.product_no
            : selectedProduct.uid,
      };
      addItem(
        params,
        (result) => {
          setReviewList((prev) => {
            const updateList = [...prev];
            updateList[currentSlideIdx].itemNo = result.itemNo;
            updateList[currentSlideIdx].itemImage = itemImage;
            updateList[currentSlideIdx].name = selectedProduct.product_name;
            updateList[currentSlideIdx].price = price;

            return updateList;
          });
        },
        () => { },
        (err) => {
          console.log(err);
        },
        token
      );
      timelineRef.current.scrollLeft = currentTime * TIMELINE_MULTIPLIER;
      setCurrentSlideIdx(currentSlideIdx);
    }
  }, [selectedProduct]);

  const addContent = () => {
    let userNo = parseInt(window.sessionStorage.getItem('userNo'));
    const title = state.search;
    let uploadData = {
      contents: {
        userNo: userNo,
        title: title,
        position: 'position',
        horizontal: true,
        videoURL: videoUrl,
        length: playerDuration,
        thumbnail: 'https://img.youtube.com/vi/' + video + '/mqdefault.jpg',
        shop: shopMode,
      },
    };

    addContents(
      uploadData,
      () => { },
      () => { },
      (e) => {
        console.log(e);
      },
      token
    ).then((response) => {
      // console.log('addContent' + response.data.contentsNo);
      updateSlideList(response.data.contentsNo);
      setConNum(response.data.contentsNo);
      setIsContentReady(true);
    });
  };

  const addCompleteContent = () => {
    // console.log('addCompleteContent')
    let userNo = parseInt(window.sessionStorage.getItem('userNo'));
    const hasMissingImageURL = reviewList.some(item => !item.imageURL);

    if (state.search === '') {
      alert('콘텐츠 제목을 입력해주세요.');
      return;
    }
    else if (reviewList.length === 0 || hasMissingImageURL) {
      alert('이미지가 등록되지 않은 슬라이드가 있습니다');
      return;
    }
    else {
      const title = state.search;
      let uploadData = {
        contents: {
          userNo: userNo,
          title: title,
          position: 'position',
          horizontal: true,
          videoURL: videoUrl,
          length: playerDuration,
          completeYn: 1,
          thumbnail: 'https://img.youtube.com/vi/' + video + '/mqdefault.jpg',
          shop: shopMode,
        },
      };
      // console.log(uploadData);
      addContents(
        uploadData,
        () => { },
        () => { },
        (e) => {
          console.log(e);
        },
        token
      ).then((response) => {
        // console.log('addContent' + response.data.contentsNo);
        updateSlideList(response.data.contentsNo);
        setConNum(response.data.contentsNo);
        setIsContentReady(true);
        closeModal();
        PushToContents();
      });
    }
  };

  const uploadButton = (contentNumber) => {
    if (!isContentReady) {
      addContent();
    } else {
      deleteSlideList();
      updateSlideList(contentNumber);
      let params = {
        title: state.search,
        contentsNo: contentNumber,
      };
      updateContents(
        params,
        () => { },
        () => { },
        () => { },
        token
      );
    }
    closeModal();
    PushToContents();
  };

  const completeButton = (contentNumber) => {
    if (!isContentReady) {
      addCompleteContent();
      // console.log('content not ready')
    } else {
      if (state.search === '') {
        alert('콘텐츠 제목을 입력해주세요.');
        return;
      } else {
        // console.log('content ready')
        deleteSlideList();
        updateSlideList(contentNumber);
        let params = {
          title: state.search,
          contentsNo: contentNumber,
          completeYn: 1,
        };
        updateContents(
          params,
          () => { },
          () => { },
          () => { },
          token
        ).then(() => {
          closeModal();
        });
      }
    }
  };

  const getReviewList = (contentNumber) => {
    const getListParam = { contentsNo: contentNumber };
    // console.log(contentNumber);
    getSlideList(
      getListParam,
      (error) => {
        console.log(error);
      },
      token
    ).then((response) => {
      // console.log('get slide list', response.data.slideList);
      if (response.data.slideList.length !== 0) {
        let slideList = response.data.slideList;
        slideList.sort((a, b) => {
          if (a.displayTime > b.displayTime) return 1;
          else return -1;
        });
        if (slideList[0].slideNo !== undefined) {
          setIsContentReady(true);
        }
        setReviewList(slideList.map((item, index) => ({ ...item, id: index })));
      } else {
        console.log('data is null');
      }
    });
  };

  const updateSlideList = (contentNo) => {
    const data = reviewList.map((item, index) => ({
      slideNo: item.slideNo,
      displayTime: item.displayTime,
      imageURL: item.imageURL,
      itemNo: item.itemNo,
    }));
    for (var i = 0; i < data.length; i++) {
      delete data[i].id;
      if (data[i].slideNo !== undefined) {
        updateSlide(
          data[i],
          () => { },
          () => { },
          (e) => {
            console.log(e);
          },
          token
        );
      } else {
        const addParams = { ...reviewList[i], contentsNo: contentNo };
        delete addParams.id;
        delete addParams.itemImage;
        delete addParams.date;
        delete addParams.name;
        delete addParams.price;
        addSlide(
          addParams,
          (e) => {
            console.log(e);
          },
          token
        );
      }
    }
  };

  const deleteSlideList = (e) => {
    // console.log('delete ', deleteSlideNumList.length);
    for (let i = 0; i < deleteSlideNumList.length; i++) {
      // console.log('delete', deleteSlideNumList[i]);
      deleteSlide(
        deleteSlideNumList[i],
        () => { },
        () => {
          setDeleteSlideNumList([]);
        },
        (e) => {
          console.log(e);
        },
        token
      );
    }
  };

  // 슬라이드 양옆에 있는 버튼 클릭시 호출되는 함수 true 왼쪽 / false 오른쪽
  const slideButtonClick = React.useCallback(
    (direction) => {
      var cur = currentSlideIdx;
      if (direction) {
        if (currentSlideIdx > 0) {
          _setPage(reviewList[cur - 1], cur - 1);
          return;
        }
      } else {
        if (cur + 1 < reviewList.length) {
          _setPage(reviewList[cur + 1], cur + 1);
          return;
        }
      }
      _setPage(reviewList[cur], cur);
    },
    [currentSlideIdx, reviewList]
  );

  // reviewList 항목 수정용 함수, wizmon은 이미지 & 비디오 시간 수정 함수 존재
  const setReviewPic = (id, reviewPicList) => {
    //console.warn("set", id, reviewPicList)
    setReviewList(
      reviewList.map((review) =>
        review.id === id ? { ...review, reviewPicList: reviewPicList } : review
      )
    );
  };
  const setdisplayTime = (index, time) => {
    //console.warn("set", id, reviewPicList)
    setReviewList(
      reviewList.map((review, idx) =>
        idx === index ? { ...review, displayTime: time } : review
      )
    );
  };

  const setPlayer = () => {
    setPlaying(!playing);
  };

  const canAddReviewItem = React.useMemo(() => {
    /*
    1) 0초, 마지막초일때 return false
    2) 현재 item 시작 시간이랑 같은 곳에는 넣을 수 없음
    3) 현재 item 끝나는 시간이랑 같은 곳에는 넣을 수 없음
    */
    const minSlideLength = 3;
    // console.log("canAddReviewItem");

    if (currentTime <= minSlideLength) return false;
    if (playerDuration - currentTime <= minSlideLength) return false;
    if (
      currentTime - reviewList[currentSlideIdx].displayTime <=
      minSlideLength
    ) {
      return false;
    }
    if (
      currentSlideIdx != reviewList.length - 1 &&
      reviewList[currentSlideIdx + 1].displayTime - currentTime <=
      minSlideLength
    )
      return false;
    //  reviewList[currentSlideIdx].displayTime
    return true;
  }, [currentTime, currentSlideIdx, reviewList, playerDuration]);

  // Drag Event 처리
  const [startX, setStartX] = useState();
  const [startTime, setStartTime] = useState(0);
  const [prevX, setPrevX] = useState();
  const [isChangeUp, setIsChageUp] = useState(false);
  const [dragMore, setDragMore] = useState(0);

  const throttle = (func, ms) => {
    let throttled = false;
    return (...args) => {
      if (!throttled) {
        throttled = true;
        setTimeout(() => {
          func(...args);
          throttled = false;
        }, ms);
      }
    };
  };

  // onMouseDown={onDragStart} // 마우스 왼쪽 버튼이 눌리는 순간
  // onMouseMove={isScrolling ? onThrottleDragMove : null} // 마우스 커서가 움직이는 순간(클릭상관X)
  // onMouseUp={onDragEnd} // 마우스 왼쪽 버튼을 떼는 순간
  // onMouseLeave={onDragEnd} // 해당 객체에서 마우스 커서가 떠나는 순간

  const onDragStart = (e) => {
    // console.log('드래그 시작');
    // console.log(e.target);
    e.preventDefault();
    setIsScrolling(true); // drag start
    setStartX(e.pageX);
  };

  const onDragEnd = (e) => {
    setDragMore(0);
    // console.log('드래그 끝');
    if (isScrolling) {
      setIsScrolling(false);
    }
  };

  // Drag 중 실행되는 이벤트, onDragStrat 직후부터 onDragEnd 전까지 계속 실행
  const onDragMove = (e) => {
    // console.log('드래그 중');
    if (dragMore > 3) {
      const { scrollWidth, clientWidth, scrollLeft } = timelineRef.current;
      // console.log("e.pageX " + e.pageX + " startX " + startX + " scrollLeft " + scrollLeft);

      // scorllTime은 현재 이벤트 위치(e.pageX)로부터 그 전 이벤트 위치(startX)을 20 나눈 만큼 움직임
      let scrollTime = (e.pageX - startX) / 20;

      // 스크롤하는 방향이 바뀔 경우 바로 방향을 바꿈
      if (isChangeUp != e.pageX - prevX > 0) {
        // console.log("isChangeUp ", isChangeUp);
        setStartX(e.pageX);
      }
      // console.log("e.pageX " + e.pageX + " prevX " + prevX);
      // console.log(e.pageX - prevX > 0 , isChangeUp, isChangeUp != (e.pageX - prevX > 0));
      setIsChageUp(e.pageX - prevX > 0);

      // scrollTime의 limit을 정해주는 함수 # 현재는 최대 3초 까지로 해놓음
      function evalScrollTime(temp) {
        let limit = 10;
        if (temp >= limit) {
          temp = limit;
        } else if (temp <= -limit) {
          temp = -limit;
        }
        return temp;
      }
      scrollTime = evalScrollTime(scrollTime);

      let time = e.pageX / TIMELINE_RULER_WIDTH;
      // console.log("time-set-move: " + parseInt(currentTime) + " to " + parseInt(scrollTime));

      // endTime과 startTime을 비교하여 0.5초 이상일때
      let endTime = new Date();
      let limitTime = 400;
      if (endTime - startTime > limitTime) {
        // console.log("over ", limitTime);
        setStartX(e.pageX);
        setStartTime(new Date());
      }

      // currentTime이 0미만으로 안떨어지게 함. currentTime에 scrollTime을 빼줌.
      // currentTime이 영상 길이 이상으로 올라가지 않게 함.
      if (currentTime - scrollTime >= playerDuration) {
        setStartTime(new Date());
        setCurrentTime(playerDuration);
        playerRef.current.seekTo(playerDuration);
      } else if (currentTime - scrollTime > 0) {
        setStartTime(new Date());
        setCurrentTime(currentTime - scrollTime);
        playerRef.current.seekTo(currentTime - scrollTime);
      } else {
        setStartTime(new Date());
        setCurrentTime(0);
      }

      setPrevX(e.pageX);
    } else {
      setDragMore(dragMore + 1);
    }
  };

  const delay = 100;
  const onThrottleDragMove = throttle(onDragMove, delay);

  const [isModal, setIsModal] = useState(false);
  const [products, setProducts] = useState([]);

  const closeModal2 = () => {
    setIsModal(false);
  };

  const handleAddSlide = () => {
    // If user is paid user
    if (isPaid) {
      addReviewItem(currentSlideIdx, currentTime);
    } else {
      if (currentSlideIdx + 1 >= 20) {
        alert(
          '무료요금제는 슬라이드 수 및 연동 가능한 상품의 수가 20개로 제한됩니다.'
        );
      } else {
        addReviewItem(currentSlideIdx, currentTime);
      }
    }
  };

  return (
    <>
      {isPreviewModalOpen ? (
        <PreviewPage
          videoUrl={videoUrl}
          slideList={reviewList}
          productList={products}
          closeModal={closeModal}
          setPreviewModalClose={() => {
            setIsPreviewModalOpen(false);
          }}
          publishedContent={publishedContent}
          publishedContents={publishedContents}
        />
      ) : (
        <div
          className="inner"
          style={{
            minWidth: 'max-content',
            width: '90%',
            height: '95vh',
            margin: 'auto',
            padding: '20px 50px',
            position: 'relative',
          }}
        >
          <div style={{}}>
            <div
              style={{
                display: 'block',
                flexDirection: 'row',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <Title
                title={location.state.isModify ? '콘텐츠 수정하기' : '콘텐츠 만들기'}
              />
              <button
                className="close"
                style={{ position: 'absolute', top: 24, right: 0 }}
              >
                <img
                  alt="닫기 버튼"
                  onClick={closeModal}
                  style={{ cursor: 'pointer' }}
                  src={closeIcon}
                />
              </button>
            </div>
            {isModal ? (
              <LinkGoods
                closeModal={closeModal2}
                handleSelectProduct={(product) => {
                  setSelectedProduct(product);
                }}
                userDetail={userDetail}
              />
            ) : (
              <>
                <div
                  style={{
                    display: 'block',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: 47,
                    paddingLeft: 60,
                  }}
                ></div>
                <div
                  style={{
                    width: 1151,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginLeft: 60,
                    marginBottom: 40,
                    justifyContent: 'space-between',
                  }}
                >
                  <p style={{ marginRight: 60, fontSize: 22 }}>제목</p>
                  <input
                    type="text"
                    style={{ width: 554, height: 50, marginRight: 5 }}
                    value={state.search}
                    onChange={handleSearch}
                    placeholder={'제목을 입력해주세요.'}
                  />
                  <button
                    style={{
                      border: `1px solid #848484`,
                      borderRadius: 20,
                      color: '#848484',
                      backgroundColor: '#fff',
                      marginLeft: 'auto',
                      padding: '6px 15px',
                      fontSize: 14,
                    }}
                    onClick={() => {
                      setIsPreviewModalOpen(true);
                      setPlaying(false);
                    }}
                  >
                    미리보기
                  </button>
                </div>
                <div>
                  <div
                    style={{
                      width: 1151,
                      height: 505,
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      marginLeft: 60,
                      marginBottom: 35,
                      justifyContent: 'space-between',
                    }}
                  >
                    <div
                      style={{
                        width: 563,
                        height: 505,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        // overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: 563,
                          height: 316.29,
                          borderRadius: 10,
                          backgroundColor: '#E7E7E7',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <VideoPlayer
                          ref={playerRef}
                          videoUrl={videoUrl}
                          playing={playing}
                          setPlaying={setPlaying}
                          width="563px"
                          height="330px"
                          onProgress={(time) => {
                            setCurrentTime(time.playedSeconds);
                          }}
                          onReady={() => {
                            let duration = playerRef.current.getDuration();

                            if (duration < 500) {
                              setTIMELINEMULTIPLIER(4);
                            }
                            setPlayerDuration(duration);
                          }}
                          isMobile={false}
                        />
                      </div>

                      {/* ! { Timeline} ! */}
                      <div style={{ width: 563 }}>
                        <div className="timelineIndicator">
                          <p
                            style={{
                              color: 'red',
                              alignSelf: 'center',
                              justifySelf: 'center',
                              width: '48px',
                            }}
                          >
                            {moment(0)
                              .second(
                                currentTime < 0 ? 0 : Math.round(currentTime)
                              )
                              .format('mm:ss')}
                            {/* {elapsed} */}
                          </p>
                        </div>
                        <div
                          style={{
                            display: 'inline',
                            color: '#848484',
                            padding: '2px 5px',
                            margin: '5px 5px',
                            float: 'right',
                          }}
                        >
                          <p style={{}}>
                            {moment(0).second(playerDuration).format('mm:ss')}
                            {/* {elapsed} */}
                          </p>
                        </div>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'column',
                          justifyContent: 'center',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            position: 'relative',
                          }}
                        >
                          <div
                            className="timelineSeekBar"
                            style={{
                              backgroundColor: '#ff0303',
                              width: 3,
                              height: 110,
                              position: 'absolute',
                              left: '50%',
                              zIndex: 100,
                              pointerEvents: 'none',
                              display: 'flex',
                              alignSelf: 'center',
                              justifySelf: 'center',
                              borderRadius: 2,
                            }}
                          ></div>

                          <div
                            className="timelineBar"
                            style={{
                              width: 563,
                              flexDirection: 'row',
                              flexWrap: 'nowrap',
                              position: 'relative',
                            }}
                            onMouseDown={onDragStart}
                            onMouseMove={
                              isScrolling ? onThrottleDragMove : null
                            }
                            onMouseUp={onDragEnd}
                            onMouseLeave={onDragEnd}
                            ref={timelineRef}
                          >
                            <div
                              className="slide"
                              style={{
                                width: 280,
                                border: '0px solid black',
                                backgroundColor: 'white',
                              }}
                            >
                              {' '}
                            </div>
                            {Slides}
                            <div
                              className="slide"
                              style={{
                                width: 280,
                                border: '0px solid black',
                                backgroundColor: 'white',
                              }}
                            >
                              {' '}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: '563px',
                          display: 'flex',
                          marginTop: 10,
                          position: 'relative',
                        }}
                      >
                        <div
                          className="slidePrev-section"
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          <button
                            className="slidePrev-btn"
                            style={{
                              width: '111.96px',
                              height: '41.5px',
                              borderTopLeftRadius: 5,
                              borderBottomLeftRadius: 5,
                              border: '1px solid #848484',
                              fontSize: '20px',
                              textAlign: 'center',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                            onClick={() => slideButtonClick(true)}
                          >
                            <img
                              src={slidePrev_Img}
                              alt="이전 슬라이드"
                              style={{ width: '25px' }}
                            />
                          </button>
                          <p
                            className="slidePrev-detail"
                            style={{
                              fontSize: '13px',
                              textAlign: 'center',
                              marginTop: '10px',
                              color: '#848484',
                            }}
                          >
                            이전 슬라이드
                          </p>
                        </div>

                        <div
                          className="playpause-section"
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          {playing ? (
                            <>
                              <button
                                className="pause-btn"
                                style={{
                                  width: 111.96,
                                  height: 41.5,
                                  border: '1px solid #848484',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  fontSize: '20px',
                                }}
                                onClick={() => setPlayer()}
                              >
                                <img
                                  src={videoPause_Img}
                                  alt="일시정지"
                                  style={{ height: '25px' }}
                                />
                              </button>
                              <p
                                className="pause-detail"
                                style={{
                                  fontSize: '13px',
                                  textAlign: 'center',
                                  marginTop: '10px',
                                  color: '#848484',
                                }}
                              >
                                일시정지
                              </p>
                            </>
                          ) : (
                            <>
                              <button
                                className="play-btn"
                                style={{
                                  width: 111.96,
                                  height: 41.5,
                                  border: '1px solid #848484',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  fontSize: '20px',
                                }}
                                onClick={() => setPlayer()}
                              >
                                <img
                                  src={videoPlay_Img}
                                  alt="재생"
                                  style={{ width: '20px' }}
                                />
                              </button>
                              <p
                                className="play-detail"
                                style={{
                                  fontSize: '13px',
                                  textAlign: 'center',
                                  marginTop: '10px',
                                  color: '#848484',
                                }}
                              >
                                재생
                              </p>
                            </>
                          )}
                        </div>

                        <div
                          className="slideNext-section"
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          <button
                            className="slideNext-btn"
                            style={{
                              width: 111.96,
                              height: 41.5,
                              border: '1px solid #848484',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '20px',
                            }}
                            onClick={() => slideButtonClick(false)}
                          >
                            <img
                              src={slideNext_Img}
                              alt="다음 슬라이드"
                              style={{ width: '25px' }}
                            />
                          </button>
                          <p
                            className="slideNext-detail"
                            style={{
                              fontSize: '13px',
                              textAlign: 'center',
                              marginTop: '10px',
                              color: '#848484',
                            }}
                          >
                            다음 슬라이드
                          </p>
                        </div>

                        <div
                          className="slideAdd-section"
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          {canAddReviewItem ? (
                            <button
                              className="slideAdd-btn able"
                              style={{
                                width: 111.96,
                                height: 41.5,
                                border: '1px solid #848484',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                              onClick={handleAddSlide}
                            >
                              <img
                                src={slideAdd_Img}
                                alt="슬라이드 추가"
                                style={{ width: '25px' }}
                              />
                            </button>
                          ) : (
                            <button
                              className="slideAdd-btn not-able"
                              style={{
                                width: 111.96,
                                height: 41.5,
                                border: '1px solid #848484',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                              onClick={() => {
                                alert(
                                  '한 슬라이드의 길이는 최소 3초 이상이어야 합니다.'
                                );
                              }}
                            >
                              <img
                                src={slideAdd_not_able_Img}
                                alt="슬라이드 추가 불가"
                                style={{ width: '25px' }}
                              />
                            </button>
                          )}
                          <p
                            className="slideAdd-detail"
                            style={{
                              fontSize: '13px',
                              textAlign: 'center',
                              marginTop: '10px',
                              color: '#848484',
                            }}
                          >
                            여기에
                            <br />
                            슬라이드 추가
                          </p>
                        </div>

                        <div
                          className="slideDelete-section"
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          {/* canAddReviewItem && currentSlideIdx != 0 */}
                          {currentSlideIdx !== 0 ? (
                            <button
                              className="slideDelete-btn able"
                              style={{
                                width: 111.96,
                                height: 41.5,
                                border: '1px solid #848484',
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                              onClick={() => {
                                deleteReviewItem(currentSlideIdx);
                              }}
                            >
                              <img
                                src={slideDelete_Img}
                                alt="슬라이드 삭제"
                                style={{ width: '25px' }}
                              />
                            </button>
                          ) : (
                            <button
                              className="slideDelete-btn not-able"
                              style={{
                                width: 111.96,
                                height: 41.5,
                                border: '1px solid #848484',
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                              onClick={() => {
                                currentSlideIdx === 0
                                  ? alert(
                                    '첫번째 슬라이드는 삭제할 수 없습니다.'
                                  )
                                  : alert(
                                    '최소 한 장의 슬라이드가 필요합니다.'
                                  );
                              }}
                            >
                              <img
                                src={slideDelete_not_able_Img}
                                alt="슬라이드 삭제 불가"
                                style={{ width: '25px' }}
                              />
                            </button>
                          )}

                          <p
                            className="slideDelete-detail"
                            style={{
                              fontSize: '13px',
                              textAlign: 'center',
                              marginTop: '10px',
                              color: '#848484',
                            }}
                          >
                            선택된
                            <br />
                            슬라이드 삭제
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: 563,
                        height: 505,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <div
                        style={{
                          position: 'relative',
                          width: 563,
                          height: 321,
                          border: '0.2px solid #000',
                          borderRadius: 10,
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent:
                            reviewList[currentSlideIdx].imageURL != null
                              ? 'space-between'
                              : 'center',
                          marginBottom: 'auto',
                          padding: '0px 12px',
                        }}
                      >
                        {reviewList[currentSlideIdx].imageURL != null && (
                          <button
                            style={{
                              backgroundColor: 'transparent',
                            }}
                            onClick={() => slideButtonClick(true)}
                          >
                            <img src={prevIcon} alt="이전 슬라이드" />
                          </button>
                        )}
                        {reviewList[currentSlideIdx].imageURL != null ? (
                          <>
                            <img
                              alt="슬라이드 이미지"
                              src={reviewList[currentSlideIdx].imageURL}
                              style={{
                                width: 473,
                                height: 320,
                                borderRadius: 10,
                                objectFit: 'scale-down',
                              }}
                            />

                            <DeleteButton
                              onClick={() => deleteSlideImage(currentSlideIdx)}
                              aria-label="슬라이드 이미지 삭제"
                            />
                          </>
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                            }}
                          >
                            <p
                              style={{
                                color: '#848484',
                                fontSize: 20,
                                textAlign: 'center',
                                marginBottom: 10,
                              }}
                            >
                              슬라이드 이미지를
                              <br />
                              등록해주세요.
                            </p>
                            <input
                              type="file"
                              name="file"
                              style={{
                                width: 170,
                              }}
                              accept="image/*"
                              onChange={(e) =>
                                uploadSlideImage(currentSlideIdx, e)
                              }
                            />
                          </div>
                        )}
                        {reviewList[currentSlideIdx].imageURL != null && (
                          <button
                            style={{
                              backgroundColor: 'transparent',
                            }}
                            onClick={() => slideButtonClick(false)}
                          >
                            <img src={nextIcon} alt="다음 슬라이드" />
                          </button>
                        )}
                      </div>
                      <div
                        style={{
                          width: 563,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <div
                          style={{
                            width: 563,
                            border: '0.2px solid #000',
                            borderRadius: 10,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 'auto',
                          }}
                        >
                          <div
                            style={{
                              width: 165,
                              height: 156,
                              borderRadius: '10px 0px 0px 10px',
                              backgroundColor: '#E7E7E7',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginBottom: 'auto',
                              borderRight: '0.2px solid #000',
                            }}
                          >
                            <img
                              alt="상품 이미지"
                              style={{
                                borderRadius: '10px 0px 0px 10px',
                                width: reviewList[currentSlideIdx].itemImage
                                  ? 165
                                  : 115,
                                height: reviewList[currentSlideIdx].itemImage
                                  ? 156
                                  : 115,
                              }}
                              src={
                                reviewList[currentSlideIdx].itemImage ||
                                faceIcon
                              }
                            />
                          </div>
                          <div
                            style={{
                              position: 'relative',
                              width: 397,
                              height: 156,
                              borderRadius: '0px 10px 10px 0px',
                              backgroundColor: 'white',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              marginBottom: 'auto',
                            }}
                          >
                            {reviewList[currentSlideIdx].itemNo ? (
                              <>
                                <DeleteButton
                                  onClick={() => deleteProduct(currentSlideIdx)}
                                  aria-label="연결한 상품 삭제"
                                />
                                <div
                                  style={{
                                    marginLeft: 27,
                                  }}
                                >
                                  <p
                                    style={{
                                      color: '#000000',
                                      fontSize: 22,
                                      marginBottom: 12,
                                    }}
                                  >
                                    {reviewList[currentSlideIdx].name}
                                  </p>
                                  <p
                                    style={{
                                      fontWeight: 700,
                                    }}
                                  >
                                    {reviewList[currentSlideIdx].price}원
                                  </p>
                                </div>
                              </>
                            ) : (
                              <div
                                style={{
                                  marginLeft: 49,
                                }}
                              >
                                <p
                                  style={{
                                    color: '#848484',
                                    fontSize: 16,
                                  }}
                                >
                                  연결된 상품이 없습니다.
                                </p>

                                <p
                                  style={{
                                    textDecoration: 'underline',
                                    textUnderlinePosition: 'under',
                                    color: '#FF7A00',
                                    fontSize: 16,
                                    cursor: 'pointer',
                                    fontWeight: 500,
                                  }}
                                  onClick={() => {
                                    setPlaying(false);
                                    setIsModal(true);
                                  }}
                                >
                                  상품 연결하기 &gt;
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: 47,
                    paddingLeft: 60,
                    paddingBottom:40,
                    marginLeft: 722,
                  }}
                >
                  {video && (
                    <button
                      style={{
                        marginRight: 10,
                        display: 'flex',
                        height: 40,
                        borderRadius: 20,
                        backgroundColor: '#CCCCCC',
                        color: '#4D4D4D',
                        fontSize: 20,
                        borderWidth: 0,
                        cursor: 'pointer',
                        fontWeight: 700,
                        padding: '10px 30px',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      onClick={() => {
                        history.push({
                          pathname:
                            '/mypage/contents-making/contents-modal/video-list',
                          state: {
                            ...location.state,
                            isModify: location.state?.isModify ?? false,
                          },
                        });
                      }}
                    >
                      영상 변경하기
                    </button>
                  )}
                  <button
                    style={{
                      display: 'flex',
                      height: 40,
                      borderRadius: 20,
                      backgroundColor: '#FFB600',
                      color: '#FFF',
                      fontSize: 20,
                      borderWidth: 0,
                      marginRight: 10,
                      fontWeight: 700,
                      padding: '10px 30px',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={() => {
                      uploadButton(contentNumber);
                      alert('콘텐츠가 임시저장 되었습니다.');
                    }}
                  >
                    임시 저장
                  </button>

                  <button
                    style={{
                      marginRight: 10,
                      display: 'flex',
                      height: 40,
                      borderRadius: 20,
                      backgroundColor: '#CCCCCC',
                      color: '#4D4D4D',
                      fontSize: 20,
                      borderWidth: 0,
                      cursor: 'pointer',
                      fontWeight: 700,
                      padding: '10px 30px',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={() => completeButton(contentNumber)}
                  >
                    저장
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ImageRegist;

const DeleteButton = styled.button`
  width: 24px;
  height: 24px;
  position: absolute;
  top: 8px;
  right: 11px;
  background-color: transparent;
  background-image: url(${deleteIcon});
  background-repeat: no-repeat;
`;
